var map = {
	"./404.svg": "a14a",
	"./account.svg": "ef22",
	"./add.svg": "c2a3",
	"./ai_call.svg": "f203",
	"./bug.svg": "1779",
	"./campus.svg": "d469",
	"./chart.svg": "c829",
	"./chinamap.svg": "773f",
	"./clipboard.svg": "bc35",
	"./company.svg": "9ef7",
	"./component.svg": "56d6",
	"./customer-service.svg": "853d",
	"./dashboard.svg": "f782",
	"./documentation.svg": "90fb",
	"./drag.svg": "9bbf",
	"./edit.svg": "aa46",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exchange.svg": "7367",
	"./exit-fullscreen.svg": "dbc7",
	"./export.svg": "077e",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./guide 2.svg": "2027",
	"./guide.svg": "6683",
	"./home.svg": "6bbe",
	"./hospital.svg": "5f91",
	"./hyperlink.svg": "2b5c",
	"./icon.svg": "9d91",
	"./import.svg": "264a",
	"./international.svg": "17df",
	"./introduce.svg": "94f8b",
	"./language.svg": "2580",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./lock.svg": "ab00",
	"./logout.svg": "0175",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./nav_data.svg": "3df1",
	"./nav_func.svg": "6dba",
	"./nav_functive.svg": "82ed",
	"./nav_pes.svg": "1e95",
	"./nav_ques.svg": "e8be",
	"./nav_sys.svg": "0604",
	"./nav_workbench.svg": "5ea8",
	"./nested.svg": "dcf8",
	"./notify.svg": "5448",
	"./ope.svg": "ff58",
	"./operationlog.svg": "bd2b",
	"./password.svg": "2a3d",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./progress.svg": "25a7",
	"./qq.svg": "1430",
	"./questionnaire.svg": "919d",
	"./report.svg": "9e5c",
	"./robot.svg": "845f4",
	"./role.svg": "520c",
	"./scan.svg": "9a02",
	"./science.svg": "c959",
	"./search.svg": "8e8d",
	"./setting.svg": "05ff",
	"./shopping.svg": "12a5",
	"./shouqi.svg": "6d25",
	"./size.svg": "8644",
	"./star.svg": "708a",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./task.svg": "771b",
	"./theme.svg": "e534",
	"./tree-table.svg": "e7c8",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./vision-exchange.svg": "e669",
	"./vision-return.svg": "60af",
	"./vs.svg": "c561",
	"./wechat.svg": "80da",
	"./wechat2.svg": "0267",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";